import React from 'react';

function Clouds() {
  return (
    <div className="cloud-background">
      <div className="white-circle cloud-5"></div>
      <div className="white-circle cloud-4"></div>
      <div className="white-circle cloud-3"></div>
      <div className="white-circle cloud-2"></div>
      <div className="white-circle cloud-1"></div>
      <div className="white-circle cloud-2 deep-blue-cloud"></div>
      <div className="white-circle cloud-2 light-blue-cloud"></div>
    </div>
  ); 
};

export default Clouds;


// WEBPACK FOOTER //
// ./frontend/components/Clouds.jsx